import apiClientCreator from "../../../../../helpers/api/request";
import { tagBN, untagBN, tagNI, untagNI, tagNA, tagTier4 } from "./tags.api";

export const groupAssignment = (client, assignTo, fromAssigning) => {
  return apiClientCreator(`client/assign/group/${client.id}`)
    .post("", {
      assign_to_group: assignTo
    })
    .then(async res => {
      if (
        client.assignment_group !== null &&
        client.assignment_group.assigned_to.id === 4
      ) {
        await untagBN(client.bn.id, client.id);
      }

      if (
        client.assignment_group !== null &&
        client.assignment_group.assigned_to.id === 3
      ) {
        await untagNI(client.ni.id, client.id);
      }
      if (assignTo === 2 || assignTo === "2") {
        await tagNA("TAG_NA", client.id);
      }

      if (assignTo === 3 || assignTo === "3") {
        await tagNI({ id: 4 }, client.id);
      }
      if (assignTo === 4 || assignTo === "4") {
        await tagBN({ id: 5 }, client.id);
      }

      if (assignTo === 5 || assignTo === "5") {
        await tagTier4(client.id);
      }

      return res;
    });
};

export const opDuplicate = (clientId, client, group) => {
  return apiClientCreator(`client/duplicate/${clientId}`)
    .post("", { group_id: group })
    .then(async res => {
      return res;
    });
};

export const setAnswer = async (answerId, clientId) => {
  return await apiClientCreator(`client/answer/${clientId}`)
    .post("", { answer_id: answerId })
    .then(async res => {
      return res;
    });
};
export const updateAnswer = (itemId, answerId, clientId) => {
  return apiClientCreator(`client/answer/${clientId}`)
    .put("", { item_id: itemId, answer_id: answerId })
    .then(res => {
      return res;
    });
};

export const updateRetired = (retired, clientId) => {
  return apiClientCreator(`client/retire/${clientId}`)
    .put("", { retired: retired })
    .then(res => {
      return res;
    });
};
